import i18n from 'i18next';

/**
 * Checks if the current language is a right-to-left (RTL) language.
 * 
 * This function uses the current language from the i18next instance and compares it 
 * against a predefined list of RTL languages. If the current language is in the list,
 * the function returns true, indicating that the language is RTL. Otherwise, it returns false.
 * 
 * @returns {boolean} True if the current language is RTL, otherwise false.
 */
export const isRTL= () => {
    const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'];
    const currentLanguage = i18n.language; // get current language from i18n
    return RTL_LANGUAGES.includes(currentLanguage);
};



export const copyToClipBoard = async (copyMe: string) => {
    try {
        await navigator.clipboard.writeText(copyMe);
        return true;
    } catch (err) {
        return false
    }
};


export const capitalize = (title: string) => {
    return title.charAt(0).toUpperCase() + title.slice(1);
}


/**
 * Converts an object into URL parameters string, removing null values.
 * @param obj The object containing key-value pairs to be converted.
 * @returns A string containing URL parameters.
 */
export function getUrlParams(obj: Record<string, any>): string {
    const params = new URLSearchParams();

    for (const key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] !== null) {
            params.append(key, obj[key]);
        }
    }

    return params.toString();
}
